import { useParams } from 'react-router-dom';
import { mapParameterToMedium } from 'modules/frequencyManagement/commonUtils';
import { FrequencyManagementParams } from 'modules/frequencyManagement/types';

export const useSelectedMedium = () => {
  const { messageMedium } = useParams<FrequencyManagementParams>();
  const mappedMedium = mapParameterToMedium(messageMedium);

  return mappedMedium;
};
